import styled from 'styled-components';

export const DraggableContainer = styled.div`
  width: 66%;
  background-color: white;
  border-radius: 10px;
  box-shadow: lightgray 0px 0px 24px 5px;
  border: 2px solid lightgray;
  overflow: auto;
  resize: vertical !important;

  @media only screen and (max-width: 960px) {
    width: 100%;
    margin-bottom: 12px;
  }
`;

export const TopBar = styled.div`
  padding: 12px 5px 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #d8d8d8;
  i {
    font-size: 18px;
    cursor: pointer;
  }
  height: 5.3em;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  h5 {
    margin: 3px 12px 0 5px;
  }
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  padding: 12px 18px;
  @media only screen and (max-width: 1440px) {
    padding: 12px;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Issue = styled.div`
  margin: 10px 0;
  background: #f2f2f2;
  border-radius: 5px;
  padding: 1.3em 1em;
  color: black;
`;
export const First = styled.div`
  display: flex;
  align-items: center;
  width: 30%;
  margin-right: 1rem;
  @media (max-width: 1750px) {
    flex-direction: column;
    align-items: flex-start;
    width: 20%;
  }
  @media (max-width: 1366px) {
    width: 30%;
  }
  @media (max-width: 960px) {
    width: 25%;
  }
`;

export const UserNameLinks = styled.div`
  margin-right: 1rem;
  width: 9em !important;
  .firstLink {
    display: flex;
    h6 {
      margin: 0 5px;
      text-decoration: underline;
    }
    .warning {
      font-size: 16px;
    }
    .crown {
      margin-top: -3px;
      color: ${(props) => props.theme.primaryDarkColor};
    }
    .dollar {
      margin-top: -3px;
      color: green;
    }
  }
`;

export const DevLiveLink = styled.div`
  display: flex;
  align-items: center;
  .link {
    display: flex;
    align-items: center;
    cursor: pointer;
    pointer-events: ${(props) => (props.loading ? 'none' : 'auto')};
    h6 {
      margin: 0 5px;
      margin-top: 5px;
      text-decoration: underline;
      color: gray;
      opacity: ${(props) => (props.loading ? 0.5 : 1)};
    }
    i {
      color: gray;
      opacity: ${(props) => (props.loading ? 0.5 : 1)};
    }
  }
`;

export const Second = styled.div`
  padding: 0 0.2em;
  margin: 0 1rem;
  width: 30%;
  cursor: pointer;
  @media (max-width: 1366px) {
    width: 40%;
  }
  @media (max-width: 960px) {
    width: 50%;
  }

  h6 {
    margin: 0;
    text-decoration: underline;
  }
  p {
    margin: 0;
    margin-top: 3px;
    color: gray;
  }
`;

export const Third = styled.div`
  margin-left: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 60%;
  cursor: pointer;

  @media (max-width: 1366px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    order: 1;
    padding: 0;
    margin: 0;
  }
`;

export const IssueName = styled.div`
  padding: 4px 14px;
  border-radius: 5px;
  font-weight: bold;
  margin: 0 1rem;
  @media (max-width: 1366px) {
    margin: 0;
  }
`;
export const Time = styled.div`
  padding: 0 0.2em;
  margin: 0 1rem;
  width: 40%;
  cursor: pointer;
  @media (max-width: 1366px) {
    width: 100%;
    padding: 0;
    margin: 0.5rem 0;
    order: 2;
  }
  p {
    margin: 0;
    margin-top: 3px;
    color: gray;
  }
`;
export const DeparmentName = styled.div`
  padding: 4px 10px;
  border-radius: 5px;
  font-weight: bold;
  background: black;
  color: white;
  @media (max-width: 1750px) {
    margin-top: 0.5em;
  }
`;

export const Last = styled.div`
  display: flex;
  align-items: center;
  width: 40%;
  .righticon {
    display: flex;
    align-items: center;
    order: 3;
  }
  @media (max-width: 1750px) {
    width: 50%;
  }
  @media (max-width: 1366px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 30%;
    margin-left: 2rem;
  }
  @media (max-width: 960px) {
    width: 25%;
  }
`;

//////////////mobile ///////////////

export const MobileContainer = styled.div``;

export const MobileFirst = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1em;
`;

export const MobileSecond = styled.div`
  margin-bottom: 1em;
  h6 {
    margin: 0;
    text-decoration: underline;
  }
  p {
    margin: 0;
    margin-top: 3px;
    color: gray;
  }
`;

export const MobileThird = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 425px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const DeparmentFlex = styled.div`
  display: flex;
  align-items: center;
  .righticon {
    display: flex;
    align-items: center;
    margin-left: 1em;
  }
  @media (max-width: 425px) {
    margin-top: 0.5em;
    justify-content: space-between;
    width: 100%;
  }
`;
export const MobileDeparmentName = styled.div`
  padding: 4px 10px;
  border-radius: 5px;
  font-weight: bold;
  background: black;
  color: white;
`;

export const MobileUserNameLinks = styled.div`
  margin-right: 1rem;
  width: 9em !important;
  .firstLink {
    display: flex;
    h6 {
      margin: 0;
      margin-right: 5px;
      text-decoration: underline;
    }
    .warning {
      font-size: 16px;
    }
    .crown {
      margin-top: -3px;
      color: ${(props) => props.theme.primaryDarkColor};
    }
    .dollar {
      margin-top: -3px;
      color: green;
    }
  }
`;
